import React, { useState, useEffect, useRef } from "react";

import {
  Button,
  Chip,
  CircularProgress,
  colors,
  Container,
  CssBaseline,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Hidden,
  makeStyles,
  Paper,
  Slide,
  Typography,
} from "@material-ui/core";

import useFetchURL from "../../../../../components/Hooks/useFetchURL";
import { uri } from "../../../../../help/Api";
import { useHistory } from "react-router-dom";
import {
  useStylesCAB,
  useStylesContainers,
  useStylesDPM,
  useStylesHed,
  useStylesSpDial,
  useStylesUiElemment,
} from "../../../../../St/comps/UseStyle";
import clsx from "clsx";
import { insh as inshst } from "../../../../../Context/InshSt";

import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import { Sync, TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import moment from "moment";
import axios from "axios";
import { insh, sto, wsto } from "../../../../../Context/InshData";
import ItemsAppBar from "./ItemsAppBar";
import ItemsForms from "./ItemsForm";
import { stElemnt } from "../../../../../St/comps/cStyle";
import { useStylesBA } from "../../../../../St/comps/UseStyle";
import { getLS } from "../../../../../utils/useLS";
import { locRem } from "../../../../../Context/Locstor";
import useBreakpoint from "../../../../../utils/useBreakpoint";
import ListItemsCon from "../ListItem/ListItemCon";
import MultiCode from "../MultiBarcode/MultiCode";
import BarcodeGenrateDialog from "../barcodePrint/BarcodeGenrateDialog";
import toast from "react-hot-toast";
import DeleteConfirmDialog from "../../../../../components/DeleteConfirmDialog";
import BarcodeGenrateCon from "../barcodePrint/BarcodeGenrateCon";
import { defaultDataUnit } from "../../subUnits/SubUnits";

const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    // direction: "rtl",
    minHeight: "100%",

  },
  itemW: {
    // display:'flex',
    width: "90%",
  },
  headerTitle: {
    backgroundColor: colors.red[50],
    textAlign: "center",
    fontSize: 20,
    width: "100%",
    fontWeight: "bold",
    marginBottom: "0.5rem"
  },

  allWidth: {
    minWidth: 650,
  },
  checStyl: {
    marginTop: "17px",
    fontSize: "16px",
    padding: "-1px",
  },
  purchTotalCard: {
    backgroundColor: colors.blue[50],
    borderColor: colors.blue[300],
  },

}));
function TransitionUp(props) {
  return <Slide {...props} direction="up" />;
}

export default function AddItems(props) {

  const { AutoOptions, locat, isDialog, DialogClose } = props;
  const SearchActivityReports = {
    id: AutoOptions.other.lastid,
    symbol: "",
    nameEN: "",
    barcode: "1111",
    group_id: null,
    group_Main: null,
    group_Sub: null,
    unit: null,
    purch_price: 0,
    sale_price: 0,
    tax: 0,
    tax_group: null,
    min_sale_price: 0,
    Distributor_price: 0,
    jomla_price: 0,
    prody_date: moment(new Date()).format("YYYY-MM-DD"),
    expiry_date: moment(new Date()).format("YYYY-MM-DD"),
    is_tab3_curr: 0,
    branch: 1,
    subUnits: [],
    amount_disc: 0,
    discount: 0,
    db_name: sto?.db_name
  };
  const autos_curr = {
    currType: [
      { id: 1, name: "مخزني" },
      { id: 2, name: "خام" },
      { id: 3, name: "صناعي" },
      { id: 4, name: "خدمي" },
      { id: 5, name: "لايباع" },
    ],
  };
  const groupsMain = AutoOptions?.groupsMain ? AutoOptions?.groupsMain : AutoOptions.Groupst;

  const inshValueAuto = {
    // group: {id: -1, name: "الكل" },
    group_id: { id: AutoOptions.Groupst[0].id, name: AutoOptions.Groupst[0].name },
    group_Main: { id: groupsMain[0]?.id, name: groupsMain[0]?.name },
    group_Sub: null,
    branch: { id: AutoOptions.Branches[0].id, name: AutoOptions.Branches[0].name },
    tax_group: { id: AutoOptions.tax_groups[0].id, name: AutoOptions.tax_groups[0].name },
    unit: { id: AutoOptions.Units[0].id, name: AutoOptions.Units[0].name },
    type: { id: autos_curr.currType[0].id, name: autos_curr.currType[0].name },
  };
  const multiCodeValue = {
    // symbol:"",
    id: 0,
    barcode: "",
    curr: AutoOptions.other.lastid,
    unitID: AutoOptions.Units[0].id,
  };
  const [items, setItems] = useState({
    ...SearchActivityReports,
    tax_group: AutoOptions.tax_groups[0].id, tax: AutoOptions.tax_groups[0].tax, type: autos_curr.currType[0].id, group_id: AutoOptions.Groupst[0].id,
    barcode: isDialog ? props.itemdata.barcode : AutoOptions.other.barcode,
    id: isDialog ? props.itemdata.id : AutoOptions.other.lastid, unit: AutoOptions.Units[0].id, subUnits: AutoOptions.Untis,
  });
  const [permiCuCo, setPrmiCuCo] = useState(AutoOptions.permiCuCo);
  const [paramsUnit, setParamsUnit] = useState(defaultDataUnit);

  const [valueAutos, setValueAutos] = useState(inshValueAuto);
  const [loadItems, setLoadItems] = useState(AutoOptions.Items);
  const [khamsItems, setkhamsItems] = useState([]);
  const [itemsComms, setItemsComms] = useState([]);
  const [multiCodeList, setMultiCodeList] = useState([]);
  const [safesVal, setSafesVal] = useState([]);

  const point = useBreakpoint();
  const [styl, setStyl] = useState(inshst.custm);
  const [isSearch, setIsSearch] = useState(false);
  const [allItems, setAllItems] = useState(AutoOptions.Items);

  const clsConts = useStylesContainers();
  const clashd = useStylesHed();
  const clasBA = useStylesBA();

  const clasCAB = useStylesCAB();
  const locSto = getLS("sto", {});
  const [loading, setLoading] = useState(insh.LoadAndSucc);
  const [success, setSuccess] = useState(insh.LoadAndSucc);
  const [showPic, setShowPic] = useState(false);
  const [or, setOr] = useState(insh.Or);
  const [allow, setAllow] = useState({ item: false, multi: false, });

  const inshParm = { itake: 20, symple: "", groupSearch: null };
  const [parm, setParm] = useState(inshParm);

  const timer = React.useRef();
  const [uiElement, setUiElement] = useState({});

  const [transition, setTransition] = React.useState(undefined);


  const [currUnitList, setCurrUnitList] = useState([]);
  const [GroupsSubs, setGroupsSubs] = useState([]);


  const [currKhamList, setCurrKhamList] = useState([]);

  const [setting, setSetting] = useState({
    screen: "",
    tb: { parms: {}, autos: {} },
  });

  const [style, setStyle] = useState({});

  const buttonClassnameNew = clsx({ [clasCAB.buttonSuccessCAB]: success.new });
  const buttonClassnameSave = clsx({
    [clasCAB.buttonSuccessCAB]: success.save,
  });
  const buttonClassnameDelete = clsx({
    [clasCAB.buttonSuccessCAB]: success.delete,
  });

  const [prevent, setPrevent] = useState(insh.prevents);

  /* s PMD */
  const [openPMD, setOpenPMD] = useState(false);
  const [barcodeDialogOpen, setBarcodeDialogOpen] = useState(false);
  const [barcodeNewDialogOpen, setBarcodeNewDialogOpen] = useState(false);
  const [openSearch, setOpenSearch] = useState(false);
  const [openMulti, setOpenMulti] = useState(false);


  const handCloseDw = async () => {
    newToI(1);
    await setOpenPMD(false);
  };
  const handOpenDw = (Transition) => {
    setTransition(() => Transition);
    setOpenPMD(true);
  };
  /* e PMD */

  const [gets, setGets] = useState(insh.tbname);

  const [kham, setKham] = useState(insh.khams);
  const [currenciesAll, setCurrenciesAll] = useState([]);
  const [isNew, setIsNew] = useState(false);




  // const ust_o = (updatedData) => {
  function usto(olddata) { }

  const reloadGets = async () => {
    const tb = {
      wait: true,
      other: true,
      // Items: true,
      parms: {
        iempid: sto.empi,
        fltrBranch: true,
        scurrenciestype: "C",
        tname: "curr",
        db_name: sto?.db_name
        // takei: 1,
      },
    };

    await axios
      .post(uri + "GetD", tb)
      .then((res) => {
        // setGets(res.data);
        setItems({
          ...SearchActivityReports,
          id: res.data.other.lastid,
          barcode: res.data.other.barcode,
          unit: AutoOptions.Units[0].id,
          // group_id: AutoOptions.Groupst[0].id,
          group_id: items?.group_id,
          type: autos_curr.currType[0].id,
          tax_group: AutoOptions.tax_groups[0].id,
          tax: AutoOptions.tax_groups[0].value,

        });

      })
      .catch((error) => {
      });
  };
  const [dataList, setDataList] = useState([]);

  const changePurchPrice = () => {
    const sum = dataList?.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.price;
    }, 0);

    setItems({ ...items, purch_price: sum });
  }
  const changAutos = async (prop, newValue) => {
    // console.log(prop+' - '+newValue.id)
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls = `RptSafes/ItemsSearch?currShow=${"F"}&&curr_type=${2}&&groupid=${-1}&&take=${200}&&item_code=${''}
          &&item_name=${''}&&emp=${sto.empi}`
    } else {
      Urls = `RptSafes/ItemsSearch?currShow=${"F"}&&curr_type=${2}&&groupid=${-1}&&take=${200}&&item_code=${''}
          &&item_name=${''}&&emp=${sto.empi}&&db_name=${sto?.db_name}`
    }
    if (prop === "type" && newValue.id === 3 && khamsItems.length == 0) {
      await axios
        .get(
          uri + Urls
        )
        .then((res) => {
          const newItems = res.data.map((row, i) => {
            return {
              ...row,
              name: row.symbol,
            };
          });
          setkhamsItems(newItems);
          setValueAutos({ ...valueAutos, [prop]: newValue });
          setItems({ ...items, [prop]: newValue.id, });
        })
        .catch((err) => {
          setkhamsItems([]);
          setValueAutos({ ...valueAutos, [prop]: newValue });
          setItems({ ...items, [prop]: newValue.id, });
        });
    } else {
      setValueAutos({ ...valueAutos, [prop]: newValue })
      setItems({
        ...items,
        [prop]: newValue.id,
        tax: prop == "tax_group" ? newValue.tax : items.tax,
      });
    }
  };

  const changTField = (prop) => (e) => {
    // console.log(prop+' - '+e.target.value)
    setItems({ ...items, [prop]: e.target.value });
  };

  const changTFSearch = (prop) => (e) => {
    setParm({ ...parm, [prop]: e.target.value, itake: 5 });
  };

  const chekeBreack = () =>
    point == "1" || point == "2" || point == "3"
      ? handOpenDw(TransitionUp)
      : null;


  const getItemsData = async (item, curr_unt, sub_barcode, itemComps) => {
    // setOr({ ...or, postput: "toPut" });
    // chekeBreack();
    setOpenPMD(false);

    let res = { group_id: {}, branch: {}, tax_group: {}, unit: {}, type: {} };
    AutoOptions.Groupst.map((x) => {
      if (x.id == item.group_id) res.group_id = x;
    });
    AutoOptions.Branches.map((x) => {
      if (x.id == item.branch) res.branch = x;
    });
    AutoOptions.tax_groups.map((x) => {
      if (x.id == item.tax_group) res.tax_group = x;
    });
    AutoOptions.Units.map((x) => {
      if (x.id == item.unit) res.unit = x;
    });
    autos_curr.currType.map((x) => {
      if (x.id == item.type) res.type = x;
    });
    setItems({
      ...items,
      id: item.id,
      barcode: item.barcode,
      nameEN: item.nameEN,
      symbol: item.symbol,
      purch_price: item.purch_price,
      sale_price: item.sale_price,
      min_sale_price: item.min_sale_price,
      Distributor_price: item.Distributor_price,
      jomla_price: item.jomla_price,
      tax: item.tax,
      img: item.img,
      type: item.type,
      group_id: item.group_id,
      unit: item.unit,
      prody_date: moment(item.prody_date).format("YYYY-MM-DD"),
      expiry_date: moment(item.expiry_date).format("YYYY-MM-DD"),
      is_tab3_curr: item?.is_tab3_curr,
      amount_disc: item?.amount_disc ?? 0,
      discount: item?.discount ?? 0,
    });

    // eds-changes
    const unitOptions = curr_unt.filter((x) => x.unit !== item.unit);

    setCurrUnitList(
      unitOptions.map((su, i) => {
        var unitName = AutoOptions.Units.find((x) => x.id === su.unit);
        return {
          // ...su, unitName: unitName ? unitName.name : "",
          ...su,
          editPerc: false,
          editUnit: false,
          editSale: false,
          editPurch: false,
          editBarcode: false,
          defUnit: {}, no: i
        };
      })
    );
    // eds-changes
    setMultiCodeList(
      sub_barcode.map((mu) => {
        return { ...mu };
      })
    );
    setValueAutos({
      ...valueAutos,
      group_id: res.group_id,
      branch: res.branch,
      tax_group: res.tax_group,
      unit: res.unit,
      type: res.type,
    });

    if (item.type == 3) {
      const dataItems = itemComps?.map((row, i) => {
        var defunit = AutoOptions.Units.find((x) => x.id == row.mat_unit);
        return {
          ...row,
          no: i,
          quan: row?.mat_quan,
          perc: parseFloat(row?.mat_quantot / row?.mat_quan).toFixed(2),
          units: [],
          unitName: defunit?.name ?? "",
          itemName: row?.itemName ?? "",
          editUnit: false,
          editquan: false,
          defUnit: {},
        };
      });
      setItemsComms(dataItems);
      let Urls = null;
      if (sto.db_name === "" || sto.db_name === null) {
        Urls = `RptSafes/ItemsSearch?currShow=${"F"}&&curr_type=${2}&&groupid=${-1}&&take=${200}&&item_code=${''}
          &&item_name=${''}&&emp=${sto.empi}`
      } else {
        Urls = `RptSafes/ItemsSearch?currShow=${"F"}&&curr_type=${2}&&groupid=${-1}&&take=${200}&&item_code=${''}
          &&item_name=${''}&&emp=${sto.empi}&&db_name=${sto?.db_name}`
      }
      await axios
        .get(
          uri + Urls
        )
        .then((res) => {
          const newItems = res.data.map((row, i) => {
            return {
              ...row,
              name: row.symbol,
            };
          });
          setkhamsItems(newItems);
        })
        .catch((err) => {
          setkhamsItems([]);
        });
      // setDataList(dataItems);
    }
    setPrevent(false);
    //  setDefultAutos(true,res);
    setUiElement({ ...uiElement, DeleIcon: false });
    timer.current = window.setTimeout(
      () => setUiElement({ ...uiElement, DeleIcon: true }),
      300
    );
    getSafeVal(item);
  };

  const getSafeVal = async (item) => {
    // setFetching(true);
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls = `TaswyaBasicData/countValSafes?curr_id=${item.id}&&barcode=${item.barcode}
                &&branch=${sto.branchi}`
    } else {
      Urls = `TaswyaBasicData/countValSafes?curr_id=${item.id}&&barcode=${item.barcode}
                &&branch=${sto.branchi}&&db_name=${sto?.db_name}`
    }
    await axios
      .get(
        uri + Urls
      )
      .then((res) => {
        if (sto.User_typei !== 1) {
          var newData = res.data?.balance.filter((obj) => obj.nameBranch === sto?.branchNames);
          setSafesVal(newData);
        } else {
          setSafesVal(res.data?.balance);
        }
      })
      .catch((err) => {
        setSafesVal([]);
      });
  };

  const handNewItem = async () => {

    await reloadGets();

    //const defaultTG = AutoOptions.tax_groups?.filter((t) => t.isDefault == true);
    setOr(insh.Or);
    setParm(inshParm);
    setUiElement({ ...uiElement, DeleIcon: false });
    setCurrUnitList([]);
    setMultiCodeList([]);
    setDataList([]);
    setSafesVal([]);
    setValueAutos({
      ...inshValueAuto,
      group_id: valueAutos.group_id
    });
    setIsSearch(false);
    setItemsComms([]);
    setParamsUnit(defaultDataUnit);
    document.getElementById("addbarcode").focus();
    // keepFocus();
  };
  const onChangeAutoGroupsMain = (propName, newValue) => {
    //  setRptParams({ ...rptParams,  group_Main: newValue.id });
    setValueAutos({ ...valueAutos, [propName]: newValue, group_Sub: {} })
    setGroupsSubs([]);

    if (newValue.id == null) {
      setGroupsSubs([]);
    } else {
      var subGroup = AutoOptions?.groupsSub?.filter((obj) => obj.parentId == newValue.id);
      if (subGroup.length > 0) {
        setGroupsSubs([...subGroup]);
        setValueAutos({ ...valueAutos, group_Sub: subGroup[0] ?? {} })
        setItems({
          ...items,
          group_id: subGroup[0]?.id,
          group_Main: newValue.id,
        });
      } else {
        setItems({
          ...items,
          group_id: newValue.id,
          group_Main: newValue.id,
        });
      }
    }
  };
  const onChangeAutoGroupsSub = (propName, newValue) => {
    // setRptParams({ ...rptParams,  group_Sub: newValue.id,group_id:  newValue.id});
    setItems({
      ...items,
      group_id: newValue.id,
      group_Sub: newValue.id,
    });
    setValueAutos({ ...valueAutos, [propName]: newValue });




  };
  const ButtonLoading = (prop) => setLoading({ ...loading, [prop]: true });

  const ButtonWitting = (prop) => {
    reloadGets(prop);
  };


  const ButtonSuccess = (prop, timr) => {
    timer.current = window.setTimeout(() => {
      setLoading({ ...loading, [prop]: false });
      setSuccess({ ...success, [prop]: true });
      if (prop != "print") handNewItem();
      setPrevent(true);
    }, timr);
  };

  const handLoads = async (value, stosn) => {
    const nstos = stosn;
    Object.keys(value).forEach((element) => {
      nstos[element] = value[element];
    });
    window.localStorage.setItem("sto", JSON.stringify(nstos));
  };



  const inputRef = useRef(null);
  const keepFocus = () => {
    inputRef.current.focus();
  };
  const newToI = (timr) => {
    ButtonLoading("new");
    ButtonSuccess("new", timr);
    // document.getElementById("addbarcode").focus();
  };

  const will = () => {
    // alert(parseFloat(items.sale_price) +' <= '+ parseFloat(items.purch_price))
    let ob = { msg: "قم بإضافة ", txt: "" };
    if (items.barcode == "") ob.txt = t("forms:barcode");
    else if (items.symbol == "") ob.txt = t("forms:product-name-ar");
    else if (items.purch_price === "") ob.txt = t("forms:purch-price");
    else if (items.sale_price == "") ob.txt = t("forms:sale-price");
    else if (parseFloat(items.sale_price) < parseFloat(items.purch_price)) {
      ob.txt = "سعر البيع اكبر او يساوي سعر الشراء";
      ob.msg = "يجب أن يكون ";
    }
    ob.msg += ob.txt;
    return ob;
  };
  const [snack, setSnack] = React.useState(insh.Snack);

  const handOSnack = (newState) => {
    setSnack({ openSnak: true, ...newState });
  };
  const handCloseMulti = async (state) => {
    // if (state === "cancle") await restPM(state);
    await setOpenMulti(false);
  };
  const [transitionsmu, setTransitionsmu] = React.useState(undefined);
  function TransitionUp(props) {
    return <Slide {...props} direction="up" />;
  }
  const addToBS = () => {
    console.log("thre group is ", items);
    let action = will();
    if (action.txt == "") {
      ButtonLoading("save");
      let item_Comps = itemsComms?.map(x => {
        console.log("thre group is ", x);
        return {
          item_id: items?.id,
          mat_id: x?.item?.id,
          mat_unit: x?.unit?.id,
          mat_quan: x?.quan,
          price: x?.price,
          mat_quantot: x?.quan_tot,
        }
      })
      const currData = {
        itemData: items,
        subBarcodes: multiCodeList,
        subUnits: currUnitList,
        item_Comps: itemsComms,
        db_name: sto?.db_name
      };
      console.log("the curre data is ", currData);

      prevent
        ? axios
          .post(uri + "Currencies", currData)
          .then((res) => {
            if (res.data) {
              alert("رقم الباردكود موجود مسبقا");
              ButtonSuccess("save", 500);
            } else {
              if (items.type === 2) {
                setkhamsItems([...khamsItems, items]);
              }
              setIsSearch(true);
              ButtonWitting("save");
              ButtonSuccess("save", 1000);
              toast.success("تمت عملية الحفظ بنجاح");
              // setIsSearch(false);

            }
          })
          .catch((res) => {
            alert("تم إضافة الصنف هذا مسبقا");
            ButtonSuccess("save", 1000);
            toast.error("خطا في عملية الحفظ");
          })
        : // axios.put('http://localhost:8184/api/Currencies', items)
        axios
          .put(uri + "Currencies", currData)
          .then((res) => {
            setIsSearch(true);
            ButtonWitting("save");
            // setCurrUnitList([]);
            ButtonSuccess("save", 1000);
            // handNewItem();
            toast.success("تمت عملية التعديل بنجاح");
            // setIsSearch(false);
          })
          .catch((res) => {
            alert("لم يتم  تعديل هذا الصنف");
            ButtonSuccess("save", 1000);
            // handNewItem();
            toast.error("لم يتم  تعديل هذا الصنف");

          });
    } else {
      alert(action.msg);
    }
  };
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });

  const hRowDelete = (id) => {
    let reResData = [...loadItems];
    reResData = reResData.filter((t) => t.id !== id);
    setLoadItems(reResData);
    setCurrenciesAll(reResData);
    ButtonSuccess("delete", 1000);
  };

  const deleteToI = async (e, id, screen) => {
    await e.preventDefault();

    if (items.type === 2) {
      var newData = khamsItems.filter((obj) => obj.id !== items.id);
      const newItems = newData.map((row, i) => {
        return {
          ...row,
          no: i,
        };
      });
      setkhamsItems(newData);
    }
    setConfirmDialog({ ...confirmDialog, isOpen: false });

    ButtonLoading("delete");
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls = `Currencies?id=${id}`
    } else {
      Urls = `Currencies?id=${id}&&db_name=${sto?.db_name}`
    }
    axios
      .delete(uri + Urls)
      .then((res) => {
        res.data != -1
          ? hRowDelete(id)
          : alert("لا يمكن حذف هذا الصنف لانه مرتبط بعمليات اخرى");
        // ButtonSuccess("delete", 500, true);
        setIsNew(true);
        ButtonSuccess("delete", 1000);

      })
      .catch((err) => {
        alert("لم يتم الحذف");
        // ButtonSuccess("delete", 500);
        setIsNew(false);
        ButtonSuccess("delete", 1000);
      });
  };

  // ==== b sd
  const [open, setOpen] = React.useState(false);

  const backHome = () => {
    his.push({ pathname: "/" });
  };
  const back = () => {
    if (!isDialog) his.goBack();
    else
      DialogClose(false);
  };

  const his = useHistory();

  const classes = useStyles();
  const clasui = useStylesUiElemment();
  const clasSp = useStylesSpDial();
  const { t } = useTranslation(["forms", "translation"]);

  const clasPM = useStylesDPM();

  const isMobileDevice = () => {
    return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
  };


  useEffect(() => {
    if (isMobileDevice()) return;

    const handleKeyDown = async (event) => {
      //  if (event.altKey && event.key ==="p"){
      if (event.key === 'F3') {

        event.preventDefault();
        let action = will();

        or.PrAC = 1;
        if (action.txt != "") {
          alert(action.txt);
        } else {
          await addToBS();
        }

      }
      if (event.key === 'F2') {
        event.preventDefault();
        await newToI(1000);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };

  }, [items, dataList, currUnitList, multiCodeList, prevent]);

  const handleOpenBarcode = () => {
    setAllow({ ...allow, item: !barcodeDialogOpen });
    setBarcodeDialogOpen(!barcodeDialogOpen);
  }; // E rsa
  const handleOpenBarcodeNew = () => {
    setAllow({ ...allow, newBarcode: !barcodeNewDialogOpen });
    setBarcodeNewDialogOpen(!barcodeNewDialogOpen);
  }; // E rsa


  const frontDialogForm = () => {
    return (
      <div>
        <Dialog
          fullScreen
          className={clasPM.rootPM}
          open={openPMD}
          onClose={handCloseDw}
          aria-labelledby="form-dialog-title"
          TransitionComponent={transition}
          key={transition ? transition.name : ""}
        >
          <DialogTitle id="form-dialog-title"
          //</Dialog> className={claslbl.clor}
          >

          </DialogTitle>
          <DialogContent
          // className={[clasPM.dialogContentPM, clasPM.diaCPMBasicDa]}
          >
            <ListItemsCon {...{
              loadItems,
              getItemsData,
              AutoOptions,
              isSearch,
              setIsSearch,
              setAllItems
            }} />
          </DialogContent>
          <DialogActions
            className={clasPM.dirRPM}>
            <div className={clasCAB.wrapperCAB}>
              <Button
                variant="outlined"
                color=""
                size="large"
                style={{ ...stElemnt.all.iconBtn }}
                className={buttonClassnameNew}
                disabled={loading.new}
                onClick={handCloseDw}
              // startIcon={<CloseIcon />}
              >
                {" "}
                {t("forms:cancel")}{" "}
              </Button>
              {loading.new && (
                <CircularProgress
                  size={24}
                  className={clasCAB.buttonProgressCAB}
                />
              )}
            </div>

            <div className={clasBA.growBA} />

          </DialogActions>
        </Dialog>
      </div>
    );
  };

  const chickBarcode = async () => {
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls = `RptSafes/ChickBarcodeItem?barcode=${items.barcode}`
    } else {
      Urls = `RptSafes/ChickBarcodeItem?barcode=${items.barcode}&&db_name=${sto?.db_name}`
    }
    await axios
      .get(
        uri + Urls
      )
      .then((res) => {
        getItemsData(res.data, res.data?.units, res.data?.currBar, res.data?.commms);
        // document.getElementById("symbol").focus();
      })
      .catch((err) => {
        document.getElementById("symbol").focus();
      });
  };


  return (
    <div className={classes.root}>
      {!props?.fromExcel &&
        (
          <Grid container item xs={12}>
            <Typography
              size="small"
              className={classes.headerTitle}
              color="primary"
            >
              {t("translation:basic-product-data")}
            </Typography>
          </Grid>
        )}

      <Typography
        component="div"
        style={{ direction: i18next.language == "ar" ? "rtl" : "rtl" }}
      >
        <Grid container item lg={12} md={12} sm={12} xm={12} className={clasui.rootchip}>

          <Grid container item lg={6} md={6} sm={6} xm={12} className={clasui.rootchip}>

            <Container
              component={Paper}
              maxWidth={false}
              style={{
                padding: "10px",
                paddingBottom: "0px",
                borderBottomColor: colors.red[50],
                borderBottomWidth: "1px",
                borderBottomStyle: "solid",
              }}
            >

              <Grid
                container
                justifyContent="center"
                lg={12}
                md={12}
                sm={12}
                xs={12}
                spacing={1}
              >
                <ItemsForms
                  {...{
                    AutoOptions,
                    items,
                    setItems,
                    changTField,
                    changAutos,
                    currUnitList,
                    setCurrUnitList,
                    valueAutos,
                    autos_curr,
                    setOpenMulti,
                    styl,
                    clasui,
                    changePurchPrice,
                    dataList,
                    setDataList,
                    onChangeAutoGroupsMain,
                    onChangeAutoGroupsSub,
                    GroupsSubs,
                    groupsMain,
                    allItems,
                    inputRef,
                    confirmDialog,
                    setConfirmDialog,
                    barcodeDialogOpen,
                    setBarcodeDialogOpen,
                    allow, setAllow, safesVal,
                    chickBarcode,
                    khamsItems,
                    itemsComms,
                    setItemsComms,
                    paramsUnit,
                    setParamsUnit
                  }}
                />

              </Grid>
            </Container>
          </Grid>

          <Hidden ony={["xs"]}>

            <Grid container item lg={6} md={6} sm={6} xs={12} className={clasui.rootchip}>
              <Grid item xs={12}>
                <ListItemsCon
                  {...{
                    loadItems,
                    getItemsData,
                    AutoOptions,
                    isSearch,
                    setIsSearch,
                    setAllItems
                  }}
                />
              </Grid>
            </Grid>
          </Hidden>
        </Grid>
        {allow.item ? (
          <BarcodeGenrateDialog
            open={barcodeDialogOpen}
            setOpen={setBarcodeDialogOpen}
            data={items}
            permiCuCo={AutoOptions.permiCuCo.CWVat}
            barcode={items.barcode}
            sale_price={Number(items?.sale_price)}
            AutoOptions={AutoOptions}
          />
        ) : null}
        {allow.newBarcode ? (
          <BarcodeGenrateCon
            open={barcodeNewDialogOpen}
            setOpen={setBarcodeNewDialogOpen}
            data={items}
            permiCuCo={AutoOptions.permiCuCo.CWVat}
            barcode={items.barcode}
            sale_price={Number(items?.sale_price)}
            AutoOptions={AutoOptions}
            itemCom={itemsComms ?? []}
            type={items.type}
          />
        ) : null}

        <MultiCode {...{
          items, multiCodeList, setMultiCodeList, openMulti,
          transitionsmu, handCloseMulti, AutoOptions, confirmDialog,
          setConfirmDialog, allow, setAllow, itemsComms
        }} />

        <DeleteConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />
        <Hidden mdUp={["md"]}> {frontDialogForm()} </Hidden>
      </Typography>
      <ItemsAppBar  {...{
        ...props,
        items,
        setBarcodeDialogOpen,
        buttonClassnameNew,
        buttonClassnameSave,
        buttonClassnameDelete,
        clasCAB,
        newToI,
        setting,
        deleteToI,
        addToBS,
        stElemnt,
        loading,
        clasui,
        clasBA,
        isDialog,
        backHome,
        back,
        setOpenSearch,
        handNewItem,
        uiElement,
        success,
        handOpenDw,
        TransitionUp,
        confirmDialog,
        setConfirmDialog,
        handleOpenBarcode,
        handleOpenBarcodeNew,
        allow, setAllow
      }} />
    </div>

  );
}
